export default "__VITE_ASSET__NiONVZ1W__"